import { BASE_URL, BASE_URL_ADMIN } from "config/environment";
import { SECTIONS } from "./MenuSections";

const {
  TASK_CENTRE,
  BHP,
  NEW_PROJECT,
  NEWMAN_TANKS,
  PERSONNEL,
  STATUS_CODES,
  ACCOMMODATION_SETUP,
  ACCOMMODATION_BOOKING,
  ROSTERS,
  FINANCIAL_REPORTS,
  MANAGEMENT_REPORTS,
  AI_REPORTS,
  FLIGHTS,
  APP_SETTING,
  MANAGEMENT,
  DATA_SOURCE,
  INTIGRATIONS,
  PINNED_ITEMS,
  ACTIVITY,
  PROJECTS,
  ACCOMODATION,
  USER_MANAGEMENT,
} = SECTIONS;

const URL = {
  WELCOME: "/welcome", // Menu A
  MENU_A: "/menua", // Menu A
  MENU_B: "/menub", // Menu B
  PROJECT: "/project",

  TASK_CENTER: `/${TASK_CENTRE}/task`,

  TASK_CENTER_FILTER: `/${TASK_CENTRE}/task/:id`,

  PINNED_ITEMS: `/${PINNED_ITEMS}/pinned`,

  ACTIVITY: `/${ACTIVITY}/activity`,

  PROJECTS: `/${PROJECTS}/projects`,

  ADD_PROJECTS: `/${NEW_PROJECT}/add/`, // Add Projects

  NEW_PROJECT: `/${PROJECTS}/projects/new`,

  PROJECT_DETAIL: `/${PROJECTS}:projectid/detail/:id`,

  BHP: `/${BHP}/bhp`,

  PERSONNEL_LIST: `/${PERSONNEL}/list/`,
  PERSONNEL_ADD: `/${PERSONNEL}/add/`,
  PERSONNEL_DETAILS: `/${PERSONNEL}/details/:id`,
  STATUS_CODE_LIST: `/${STATUS_CODES}/list/`,
  STATUS_CODE_ADD: `/${STATUS_CODES}/add/`,
  STATUS_CODE_EDIT: `/${STATUS_CODES}/edit/:id`,
  ACCOMMODATION_SETUP_LIST: `/${ACCOMMODATION_SETUP}/list/`,
  ACCOMMODATION_SETUP_ADD: `/${ACCOMMODATION_SETUP}/add/`,
  ACCOMMODATION_SETUP_EDIT: `/${ACCOMMODATION_SETUP}/edit/:id`,
  ACCOMMODATION_BOOKING_LIST: `/${ACCOMMODATION_BOOKING}/list/`,
  ACCOMMODATION_BOOKING_ADD: `/${ACCOMMODATION_BOOKING}/add/`,
  ACCOMMODATION_BOOKING_EDIT: `/${ACCOMMODATION_BOOKING}/edit/:id`,
  ROSTER_LIST: `/${ROSTERS}/list/`,
  ROSTER_ADD: `/${ROSTERS}/add/`,
  ROSTER_EDIT: `/${ROSTERS}/edit/:id`,

  FLIGHTS_LIST: `/${FLIGHTS}/list/`,

  ACCOMODATION_LIST: `/${ACCOMODATION}/list`,

  MANAGEMENT_REPORTS: `/${MANAGEMENT_REPORTS}/reports/management`,

  FINANCIAL_REPORTS: `/${FINANCIAL_REPORTS}/reports/financial`,

  AI_REPORTS: `/${AI_REPORTS}/reports/ai`,

  APP_SETTING: `/${APP_SETTING}/setting`,

  MANAGEMENT: `${BASE_URL_ADMIN}smart-roster/admin/`,

  DATA_SOURCE: `/${DATA_SOURCE}/setting/datasource`,

  INTIGRATIONS: `/${DATA_SOURCE}/setting/intigrations`,

  USER_MANAGEMENT: `/${USER_MANAGEMENT}/list/`,

  MY_CHANGE_REQUESTS: `/change-requests/my-requests`,
  ARCHIVED_PROJECTS: `/archived-projects/list`,
  REVIEW_CHANGE_REQUESTS: `/change-requests/review`,

  NOTIFICATIONS: "/notifications",

  AUTH: {
    LOGIN: "/login", // Login
    FORGOT_PASSWORD: "/forgotpassword", // Forgot Password
    LINK: "/forgotlink", // Link Screen
    RESET_PASSWORD: "/resetpassword/:uid/:token",
    VERIFY_EMAIL: "/verify-email/:token",
  },
  ERROR: {
    PAGE404: "/page404",
    PAGE500: "/page500",
  },
};

export default URL;
